module.exports = __webpack_public_path__ + "static/bca-46a3c3fa9b60913c1022a4ad0aaacf3e.png";